// extracted by mini-css-extract-plugin
export default {"wrapper":"Error404_wrapper__sXjW0","error404":"Error404_error404__2wZH+"};